
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";
import MajorShoppingInfoHistoryComponent from "@/components/admin/landing/major-shopping/MajorShoppingInfoHistory.vue";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading, MajorShoppingInfoHistoryComponent },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
    };
  },
  methods: {
    submitMainBanner() {
      const mainBanner = store.state.admin.landing.majorShopping.mainBanner;

      store.dispatch("admin/uploadMajorShoppingMainBanner", {
        image: this.chosenFile,
      });
    },
    submitContent() {
      const data = {
        title: this.title,
        subTitle: this.subTitle,
        text: this.description,
        language: this.language,
      };
      store.dispatch("admin/submitMajorShoppingContent", data);
    },
    submitMajorShoppingContent() {
      const data = store.state.admin.landing.majorShoppingInfo;
      store.dispatch("admin/createMajorShoppingInfo", data);
    },
    uploadMainBannerImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateMainBannerMajorShopping",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    title: {
      get(): string {
        return store.state.admin.landing.majorShopping.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateMajorShoppingTitle", value);
      },
    },

    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    subTitle: {
      get(): string {
        return store.state.admin.landing.majorShopping.subTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateMajorShoppingSubTitle", value);
      },
    },

    subTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    language: {
      get(): string {
        return store.state.admin.landing.majorShopping.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateMajorShoppingLanguage", value);
      },
    },
    languageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.language?.$dirty) {
        return errors;
      }
      !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    description: {
      get(): string {
        return store.state.admin.landing.majorShopping.text;
      },
      set(value: string): void {
        store.dispatch("admin/updateMajorShoppingDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    // major shopping info
    languageInfo: {
      get(): string {
        return store.state.admin.landing.majorShoppingInfo.language;
      },
      set(value: string): void {
        store.dispatch("admin/updateMajorShoppingInfoLanguage", value);
      },
    },

    languageInfoError(): string[] {
      const errors: string[] = [];
      if (!this.$v.languageInfo?.$dirty) {
        return errors;
      }
      !this.$v.languageInfo.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    phone: {
      get(): string {
        return store.state.admin.landing.majorShoppingInfo.phone;
      },
      set(value: string): void {
        store.dispatch("admin/updateMajorShoppingInfoPhone", value);
      },
    },

    phoneError(): string[] {
      const errors: string[] = [];
      if (!this.$v.phone?.$dirty) {
        return errors;
      }
      !this.$v.phone.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    email: {
      get(): string {
        return store.state.admin.landing.majorShoppingInfo.email;
      },
      set(value: string): void {
        store.dispatch("admin/updateMajorShoppingInfoEmail", value);
      },
    },

    emailError(): string[] {
      const errors: string[] = [];
      if (!this.$v.email?.$dirty) {
        return errors;
      }
      !this.$v.email.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    address: {
      get(): string {
        return store.state.admin.landing.majorShoppingInfo.address;
      },
      set(value: string): void {
        store.dispatch("admin/updateMajorShoppingInfoAddress", value);
      },
    },

    addressError(): string[] {
      const errors: string[] = [];
      if (!this.$v.address?.$dirty) {
        return errors;
      }
      !this.$v.address.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      store.dispatch("admin/updateProductCategory", id);
    }
  },
  validations: {
    title: {
      required,
    },
    subTitle: {
      required,
    },
    language: {
      required,
    },
    description: {
      required,
    },
    phone: {
      required,
    },
    email: {
      required,
    },
    languageInfo: {
      required,
    },
    address: {
      required,
    },
  },
});
